import Archive from './Archive';
import './Archive.scss';

export default Archive;
